(() => {
  const context = document.getElementById('RubyWhatsAppContext');
  if (!context) return;
  const variants = new Map(JSON.parse(context.querySelector('script').textContent).map(v => [String(v.id), v]));
  let pending = false;
  const main = () => document.querySelector('product-info[id^="MainProduct-"]');
  const links = () => [...document.querySelectorAll('[data-ruby-whatsapp-product]')].filter(a => a.dataset.rubyWhatsappProduct === context.dataset.productId);
  function update() {
    const input = main()?.querySelector('form[action*="/cart/add"] input[name="id"]');
    const variant = variants.get(String(input?.value || ''));
    for (const link of links()) {
      if (pending || !variant) {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        continue;
      }
      const url = new URL(context.dataset.productUrl);
      url.searchParams.set('variant', variant.id);
      const priceMatch = link.dataset.rubyPriceMatchMessage;
      const rawSku = String(variant.sku || '').trim();
      const sku = priceMatch ? rawSku.replace(/-LIVE$/, '') : rawSku;
      const label = sku ? context.dataset.skuLabel : context.dataset.idLabel;
      const intro = priceMatch
        ? priceMatch.replace(/__LABEL__|__SKU__/g, token => token === '__LABEL__' ? label : (sku || context.dataset.productId))
        : [link.dataset.rubyWhatsappIntro || context.dataset.intro, context.dataset.title, `${label}: ${sku || context.dataset.productId}`].join('\n');
      const productLink = `${context.dataset.linkLabel}: ${url.href}`;
      const message = (priceMatch ? [productLink, intro] : [intro, productLink]).join('\n');
      link.href = `https://wa.me/972527277066?text=${encodeURIComponent(message)}`;
      link.removeAttribute('aria-disabled');
    }
  }
  document.addEventListener('change', event => {
    const productInfo = main();
    if (!productInfo?.contains(event.target)) return;
    if (event.target.closest('variant-selects')) pending = true;
    else if (event.target.matches('input[name="id"]')) pending = false;
    else return;
    update();
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ruby-whatsapp-product]');
    if (!link || link.dataset.rubyWhatsappProduct !== context.dataset.productId) return;
    update();
    if (link.getAttribute('aria-disabled') === 'true') event.preventDefault();
  }, true);
  const observer = new MutationObserver(() => update());
  if (main()) observer.observe(main(), { childList: true, subtree: true });
  window.addEventListener('pageshow', update);
  update();
})();
